export const SELECT_DATE_RANGE = 'SELECT_DATE_RANGE'

export const SELECT_DATE_START = 'SELECT_DATE_START'
export const SELECT_DATE_END = 'SELECT_DATE_END'

export const DOWNLOAD_XLSX = 'DOWNLOAD_XLSX'
export const DOWNLOAD_CSV = 'DOWNLOAD_CSV'

export const CALC_TASK_RELATIVE_VALUES_TO_STATE = 'CALC_TASK_RELATIVE_VALUES_TO_STATE'